/** @jsx jsx */

import type { ReactNode } from 'react';

import { Icon } from '@zapier/zinnia-icons';
import { Button, Margin } from '@zapier/design-system';
import { jsx } from '@emotion/core';

type Props = {
  children: ReactNode;
  onClickTestAgain: () => void;
};

const Wrapper = (props: Props) => {
  return (
    <Margin margin="20px">
      <Margin margin="0px 0px 20px 0px">{props.children}</Margin>
      <Button
        aria-label="Test Again"
        variant="secondary"
        onPress={props.onClickTestAgain}
        iconPosition="start"
      >
        <Icon name="arrowSmallLeft" />
        Test Again
      </Button>
    </Margin>
  );
};

Wrapper.defaultProps = {
  children: null,
};

export default Wrapper;
